import config from './config'

let API_URL = config.API_URL

if (process.env.REACT_APP_LOCAL == "true") API_URL = config.API_LOCAL_URL;

export default API_URL;
